export default __webpack_public_path__ + "static/media/home-search-jobs.9d0676de.jpg";